import { Card, Form, Button, Input, Col, Checkbox, Divider, Row, Tooltip, Space, Grid } from 'antd';
import {
  useCompanyData,
  useSendTelegramTestMessage,
} from '../../../../../../../../Hooks/TT_ELD/Companies';
import { companies } from '../../../../../../../../API/TT_ELD/Users/company';
import { sendEvent } from '../../../../../../../../Utils/analytics';
import { getProviderFromUrl } from '../../../../../../../../Utils/providerURL';
import { useProjectData } from '../../../../../../../../Hooks/useProjectData';

const { useBreakpoint } = Grid;

type MyObjectType = {
  [key: string | number]: any;
};

const NotificationsTab = ({ companyId }: { companyId: any }) => {
  const [form] = Form.useForm();

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(companyId);
  const { mutate, isLoading: isPending } = useSendTelegramTestMessage();

  const normalizeValue = (v: any) => v || null;

  const onSubmit = async (values: any) => {
    values = {
      ...values,
      notificationChatId: normalizeValue(values.notificationChatId),
      notificationEmail: normalizeValue(values.notificationEmail),
      config: {
        ...values.config,
        eldType: await companies.latestEldType(companyId),
        notificationEldFault: data?.config?.notificationEldFault,
        notificationEldDisconnectGlobal: data?.config?.notificationEldDisconnectGlobal,
        project44Id: data?.config?.project44Id,
      },
    };
    const body: MyObjectType = {};

    let key: string | number;
    let key2: string | number;
    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) != JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }

    sendEvent(
      `Company page`,
      `Company  Tab Notification  `,
      `Company page Tab Notification Submit`,
      1,
    );
    companies.companyPatchData(body, companyId);
    refetch();
  };

  const handleNotificationTestMessage = () => {
    const chatId = form.getFieldValue('notificationChatId');

    if (!chatId) {
      return;
    }

    const payload = {
      chatId,
      botType: `eld`,
      message: 'Success! Your chat has been connected, and notifications will now be sent here',
    };

    mutate(payload);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  type FieldType = {
    notificationChatId?: number;
    notificationEmail?: string;
    type?: string;
    chatId?: string;
  };

  const { projectData } = useProjectData();

  const provider = getProviderFromUrl(projectData.baseUrl);

  return (
    <Card loading={isLoading || isFetching} style={{ width: '100%' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        name="notifications"
        initialValues={{
          ...data,
        }}
      >
        <Row gutter={[16, 10]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <Form.Item<FieldType>
              wrapperCol={{ span: '100%' }}
              label={
                <span>
                  Notification Chat ID{' '}
                  <span style={{ color: '#999' }}>
                    {`(Supported bots: @control_${provider}_bot)`}
                  </span>
                </span>
              }
            >
              <Space.Compact style={{ width: '100%' }}>
                <Form.Item name="notificationChatId" noStyle>
                  <Input placeholder="Enter Chat ID" />
                </Form.Item>
                <Button type="primary" loading={isPending} onClick={handleNotificationTestMessage}>
                  Test Message
                </Button>
              </Space.Compact>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={8}>
            <Form.Item<FieldType>
              wrapperCol={{ span: '100%' }}
              label="Notification Email"
              name="notificationEmail"
            >
              <Input placeholder="Enter Email" />
            </Form.Item>
          </Col>
        </Row>

        <>
          <Divider />
          <Form.Item
            label="Notification Type"
            shouldUpdate={(prevValues, currentValues) => prevValues.config !== currentValues.config}
          >
            {() => {
              return (
                <>
                  <Space
                    direction={isMobile ? 'vertical' : 'horizontal'}
                    size={isMobile ? 8 : 24}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexWrap: isMobile ? 'nowrap' : 'wrap',
                      alignItems: isMobile ? 'stretch' : 'center',
                    }}
                  >
                    <Form.Item
                      name={['config', 'notificationWeighStation']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox style={{ width: isMobile ? '100%' : 'auto' }}>
                        Weigh Station
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name={['config', 'notificationEldDisconnect']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox style={{ width: isMobile ? '100%' : 'auto' }}>
                        ELD Disconnect
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name={['config', 'notificationEldFaultByCompany']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox style={{ width: isMobile ? '100%' : 'auto' }}>
                        Truck Fault Code
                      </Checkbox>
                    </Form.Item>
                  </Space>
                </>
              );
            }}
          </Form.Item>
        </>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default NotificationsTab;
